import { useAuth } from '@/hooks/useAuth';
import { useLocation } from 'react-router-dom';
import StudyAssistant from '@/components/StudyAssistant';

const authenticatedPaths = [
  '/dashboard', '/profile', '/affiliates', '/leaderboard',
  '/academy', '/payment-success',
];

const AuthenticatedWidgets = () => {
  const { user } = useAuth();
  const location = useLocation();

  const isAuthPage = authenticatedPaths.some(p => location.pathname.startsWith(p));

  if (!user || !isAuthPage) return null;

  return <StudyAssistant />;
};

export default AuthenticatedWidgets;
